module.exports = __webpack_public_path__ + "img/logo.6547dd91.png";